import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=3e7bccb6&"
import script from "./loading.js?vue&type=script&lang=js&"
export * from "./loading.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports